import { createAsyncThunk } from '@reduxjs/toolkit'
import { listingsData } from '@assets/mockdata'
import { Listing, UpdateListingThunkParams } from '@dataTypes/index'

export const fetchAllListings = createAsyncThunk(
  'listings/fetchAllListings',
  async () => {
    return listingsData
  },
)

export const addListing = createAsyncThunk(
  'listings/addListing',
  async (body: Listing) => {
    return body
  },
)

export const updateListing = createAsyncThunk(
  'listings/updateListing',
  async (params: UpdateListingThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeListing = createAsyncThunk(
  'listings/removeListing',
  async (index: string) => {
    return index
  },
)
